export { default } from './WSA05InspectionProps.component';
export { getDomainValues as getWSA05DomainValues } from './WSA05InspectionProps.component';
